module.exports = __webpack_public_path__ + "static/img/Gruber-Carina.7bf5a87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/at/Gruber-Carina.jpg
// module id = Z8SS
// module chunks = 1